(function (angular) {
    'use strict';

    angular.module('rcs')

        /**
         *
         */
        .factory('rcsServices',
            ['$http', '$q', 'profilesService', 'portalConfig',
                function ($http, $q, profilesService, portalConfig) {

                    var urlBase = portalConfig.urlBase;
                    // var urlBase = "http://localhost:8001";
                    var fac = {
                        getAllRcsConfigurations: getAllRcsConfigurations,
                        inviteTestUser: inviteTestUser,
                        removeTestUser: removeTestUser,
                        getRcsAgent: getRcsAgent,
                        getAgentsTestersProfiles: getAgentsTestersProfiles,
                        capabilityCheck: capabilityCheck,
                        setDefaultAgent: setDefaultAgent
                    };

                    return fac;

                    function capabilityCheck(apiSpaceId, agentId, phoneNumber) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/rcs/" + agentId + "/capabilities/" + phoneNumber).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            return $q.reject(error);
                        });
                    }

                    function getAllRcsConfigurations(apiSpaceId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/rcs").then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function getRcsAgent(apiSpaceId, agentId) {
                        return $http.get(urlBase + "/apispaces/" + apiSpaceId + "/channels/rcs/" + agentId).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function getAgentsTestersProfiles(apiSpaceId, testers) {
                        var promises = [];
                        if (!testers || !testers.length) {
                            return $q.resolve([]);
                        }
                        for (var testerId of testers) {
                            promises.push(profilesService.getProfile(apiSpaceId, testerId));
                        }
                        return $q.all(promises);
                    }

                    function inviteTestUser(apiSpaceId, agentId, phoneNumber) {
                        var data = {
                            phoneNumber: phoneNumber
                        };
                        return $http.post(urlBase + "/apispaces/" + apiSpaceId + "/channels/rcs/" + agentId + "/tester", data).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function removeTestUser(apiSpaceId, agentId, profileId) {
                        return $http.delete(urlBase + "/apispaces/" + apiSpaceId + "/channels/rcs/" + agentId + "/tester/" + profileId).then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            console.error(JSON.stringify(error));
                            return $q.reject(error);
                        });
                    }

                    function setDefaultAgent(apiSpaceId, agentId) {
                        return $http.put(urlBase + "/apispaces/" + apiSpaceId + "/channels/rcs/" + agentId + "/default").then(function (response) {
                            return response.data;
                        }).catch(function (error) {
                            return $q.reject(error);
                        });
                    }
                }]);

})(window.angular);
